import React from "react";
import "../../scss/dashboard/plantillasVendidas.css";
import { usePublicTemplateList } from "../../api/hooks/public-templates";
import { Spinner } from "reactstrap";

import NoStatusScreen from "./indexBoxes/NoStatusScreen";

export function Table({
  cols = [],
  items,
  isLoading,
  sortBy = "updatedAt",
  width,
}) {
  if (!cols.length) return null;

  return (
    <div
      className="grande dashboardabogados-table mostSold__table"
      style={{ width: `${width}%` }}
    >
      <div
        className="inicio__box1 saldo__texto StatusTable"
        style={{
          paddingBottom: "5px",
        }}
      >
        <h3 className="font-weight-bold">Estatus de plantillas</h3>
        <div
          style={{
            // overflowY: "scroll",
            maxHeight: "400px",
          }}
        >
          <table className="table">
            <tr>
              {cols.map((col) => (
                <th>{col.label}</th>
              ))}
            </tr>
            {isLoading && (
              <tr>
                <td className="text-center" colSpan={cols.length}>
                  <Spinner />
                </td>
              </tr>
            )}
            {!isLoading &&
              items?.map((publicTemplate, i) => (
                <tr>
                  {cols.map((col) => (
                    <td className={col.className}>
                      {col.render ? (
                        col.render(publicTemplate, i)
                      ) : (
                        <p>{publicTemplate[col.key || "_id"]}</p>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            {!isLoading && !items?.length && (
              <tr>
                <td colSpan={cols.length}>
                  <NoStatusScreen />
                </td>
              </tr>
            )}
          </table>
        </div>
      </div>
    </div>
  );
}
